import React from 'react'
//UI
import {
  Grid,
  Paper,
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  MenuItem,
} from '@material-ui/core'
//Components
import { EditableTextField, EditableSwitch, EditableSelect } from '../common/EditableComponents'
//Utils
import {
  biotrackEnvironmentOptions as environmentOptions,
  biotrackModeOptions,
} from '../../utils/constants'
import BiotrackNewItemContainer from './BiotrackNewItemContainer'
import { getAuthorizationUrl } from '../../api/complianceService'
import { openErrorMessage } from '../../actions/message'
import moment from 'moment'

export default class BiotrackLocations extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
    }
  }

  handleAuthorize = async (location) => {
    this.setState({ isLoading: true })
    const { companyId, shopId } = location

    try {
      const redirectAfter = `${window.location.origin}/settings/integration/compliance/permissions`
      const oauthRedirect = await getAuthorizationUrl(companyId, shopId, redirectAfter)
      if (oauthRedirect?.url) window.location.href = oauthRedirect.url
    } catch (err) {
      const detail = err?.response?.data?.errors?.[0]?.detail || 'Failed'
      this.props.dispatch(openErrorMessage(detail))
    } finally {
      this.setState({ isLoading: false })
    }
  }

  render() {
    const { isLoading } = this.state
    const { data, shops, onChangeLocation, editMode, onAddNewLocation } = this.props
    const { locations = [], facilities = [] } = data

    const enabledMetrcShopsId =
      facilities.length !== 0 &&
      facilities.filter((facility) => facility.enabled).map((facility) => facility.shopId) //Enabled metrc
    const editableLocations =
      enabledMetrcShopsId &&
      locations.filter((location) => !enabledMetrcShopsId.includes(location.shopId)) //Editable

    const availableShops =
      locations &&
      shops &&
      facilities &&
      shops.filter(
        (shop) =>
          (!locations.includes(locations.find((location) => location.shopId === shop.id)) &&
            !facilities.includes(
              facilities.find((facility) => facility.shopId === shop.id), // No metrc or location record in Shop
            )) ||
          (!locations.includes(locations.find((location) => location.shopId === shop.id)) &&
            facilities.includes(
              facilities.find(
                (facility) => facility.shopId === shop.id && facility.enabled === false,
              ), // No location record and disabled in metrc
            )),
      )

    const showOAuthActions = (editableLocations || []).some(
      (location) => location?.isBiotrackOAuthConfigured,
    )

    return (
      <React.Fragment>
        <Grid container>
          <Grid className="unversalScroll" item xs={12}>
            <Paper className="paper-page">
              <div className="table-scroll">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ minWidth: 150 }}>Shop Name</TableCell>
                      <TableCell>App Type</TableCell>
                      <TableCell>Mode</TableCell>
                      <TableCell style={{ minWidth: 100 }}>Environment</TableCell>
                      <TableCell style={{ minWidth: 70 }}>Location</TableCell>
                      <TableCell style={{ minWidth: 100 }}>License UBI</TableCell>
                      <TableCell style={{ minWidth: 150 }}>Username</TableCell>
                      <TableCell style={{ minWidth: 70 }}>Password</TableCell>
                      {showOAuthActions && (
                        <>
                          <TableCell style={{ minWidth: 80 }}>Exp. date</TableCell>
                          <TableCell></TableCell>
                        </>
                      )}
                      <TableCell>Enabled</TableCell>
                      <TableCell>Delivery Enabled</TableCell>
                      <TableCell>Enable Sync</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {editableLocations &&
                      editableLocations.map((location, keyIndex) => {
                        const index = location.id
                        const selectedShop = shops.find((shop) => location.shopId === shop.id) || {}
                        const isExpired = location.expirationDate
                          ? new Date(location.expirationDate) < new Date()
                          : true

                        const credentialsCells = (
                          <React.Fragment>
                            <TableCell>
                              <EditableTextField
                                valueToRender={location.userName}
                                editMode={editMode}
                                value={location.userName}
                                onChange={onChangeLocation(index, 'userName')}
                                type="text"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </TableCell>
                            <TableCell>
                              <EditableTextField
                                valueToRender={editMode ? location.password : '*******'}
                                editMode={editMode}
                                value={location.password}
                                onChange={onChangeLocation(index, 'password')}
                                type="text"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </TableCell>
                          </React.Fragment>
                        )

                        const locationCells = (
                          <React.Fragment>
                            <TableCell className="cell-wrap-word">
                              <EditableSelect
                                valueToRender={location.mode}
                                editMode={editMode}
                                value={location.mode}
                                onChange={onChangeLocation(index, 'mode')}
                              >
                                {biotrackModeOptions.map((env, index) => {
                                  return (
                                    <MenuItem key={index} value={env.value}>
                                      {env.label}
                                    </MenuItem>
                                  )
                                })}
                              </EditableSelect>
                            </TableCell>
                            <TableCell className="cell-wrap-word">
                              <EditableSelect
                                valueToRender={location.environment}
                                editMode={editMode}
                                value={location.environment}
                                onChange={onChangeLocation(index, 'environment')}
                              >
                                {environmentOptions.map((env, index) => {
                                  return (
                                    <MenuItem key={index} value={env.value}>
                                      {env.label}
                                    </MenuItem>
                                  )
                                })}
                              </EditableSelect>
                            </TableCell>
                            <TableCell>
                              <EditableTextField
                                valueToRender={location.locationLicense}
                                editMode={editMode}
                                value={location.locationLicense}
                                onChange={onChangeLocation(index, 'locationLicense')}
                                type="text"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </TableCell>
                            <TableCell>
                              <EditableTextField
                                valueToRender={location.licenseUBI}
                                editMode={editMode}
                                value={location.licenseUBI}
                                onChange={onChangeLocation(index, 'licenseUBI')}
                                type="text"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </TableCell>
                            {credentialsCells}
                            {showOAuthActions && (
                              <>
                                <TableCell style={{ color: isExpired ? 'red' : undefined }}>
                                  {location.isBiotrackOAuthConfigured &&
                                  moment(location.expirationDate).isValid()
                                    ? moment(location.expirationDate).format('MM/DD/YYYY')
                                    : ''}
                                </TableCell>
                                <TableCell>
                                  {location.isBiotrackOAuthConfigured && (
                                    <button
                                      className="primary-button padding-small"
                                      style={{ cursor: !isLoading ? 'pointer' : 'not-allowed' }}
                                      onClick={() => this.handleAuthorize(location)}
                                      disabled={isLoading}
                                    >
                                      {isExpired ? 'Authorize' : 'Re-Authorize'}
                                    </button>
                                  )}
                                </TableCell>
                              </>
                            )}
                            <TableCell>
                              <EditableSwitch
                                valueToRender={location.enabled ? 'Enabled' : 'Disabled'}
                                checked={location.enabled}
                                editMode={editMode}
                                onChange={onChangeLocation(index, 'enabled', true)}
                              />
                            </TableCell>
                            <TableCell>
                              <EditableSwitch
                                valueToRender={location.deliveryEnabled ? 'Enabled' : 'Disabled'}
                                checked={location.deliveryEnabled}
                                editMode={editMode}
                                onChange={onChangeLocation(index, 'deliveryEnabled', true)}
                              />
                            </TableCell>
                            <TableCell>
                              <EditableSwitch
                                valueToRender={location.enableSync ? 'Enabled' : 'Disabled'}
                                checked={location.enableSync}
                                editMode={editMode}
                                onChange={onChangeLocation(index, 'enableSync', true)}
                              />
                            </TableCell>
                          </React.Fragment>
                        )

                        return (
                          <TableRow key={keyIndex}>
                            <TableCell>{selectedShop.name && selectedShop.name}</TableCell>
                            <TableCell>{selectedShop.appTarget}</TableCell>

                            {locationCells}
                          </TableRow>
                        )
                      })}
                    {availableShops &&
                      availableShops.map((shop, index) => {
                        return (
                          <TableRow key={index}>
                            <TableCell>{shop.name && shop.name}</TableCell>
                            <TableCell>{shop.appTarget}</TableCell>
                            {editMode ? (
                              <BiotrackNewItemContainer
                                shop={shop}
                                onAddNewLocation={onAddNewLocation}
                              />
                            ) : null}
                          </TableRow>
                        )
                      })}
                  </TableBody>
                </Table>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Compliance/BiotrackLocations.js